<script setup lang="ts">
import {useShare} from '@vueuse/core'
import LangSwitcher from "~/components/LangSwitcher.vue";
const {t} = useI18n()

const {share, isSupported} = useShare()

const shareTitle = computed(() => t('shareTitle'))
const shareText = computed(() => t('shareText'))

function startShare() {
  let url = new URL(location.href);
  url.searchParams.delete('emu');

  share({
    title: shareTitle.value,
    text: shareText.value,
    url: url.toString(),
  })
}
</script>

<template>
  <header class="sticky top-0 z-50 border-b border-stone-200/80 bg-stone-50/80 backdrop-blur-md">
    <div class="mx-auto flex h-16 max-w-2xl items-center justify-between gap-3 px-4 sm:px-6">
      <img src="/Explorial_Logo.svg" alt="Explorial" class="h-7 w-auto"/>
      <div class="flex items-center gap-1">
        <LangSwitcher/>
        <button
          v-if="isSupported"
          class="grid h-10 w-10 place-items-center rounded-full text-stone-600 transition hover:bg-stone-200/70 hover:text-stone-900"
          aria-label="Share"
          @click="startShare">
          <UIcon class="h-5 w-5" name="i-heroicons-share"/>
        </button>
      </div>
    </div>
  </header>
</template>

<style scoped>
</style>
